"use strict";

var campaign = (function () {
    var t = setTimeout(function () {

        $('.ganttview-block-container').tooltip({
            track: true,
            items: '.ganttview-block',
            content: function () {
                var $this = $(this),
                    tooltipTitle = $this.attr('data-title'),
                    tooltipText = $this.attr('data-description');

                return '<h5>' + tooltipTitle + '</h5><p>' + tooltipText + '</p>'
            },
            position: { my: "center bottom-15", at: "center bottom" },
            tooltipClass: "campaigntooltip"
        });
    }, 500);
})();